import { render, staticRenderFns } from "./VxAvatar.vue?vue&type=template&id=d16c2402&lang=html"
import script from "./VxAvatar.vue?vue&type=script&lang=js"
export * from "./VxAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports